import { useTranslation } from 'react-i18next';

import { OnRefresh, SelectedPosition } from '../types';
import { evaluateErpNumber } from '../utils';

import { ErpDialogArticleGroupedPositionsProps } from './ErpDialogArticleGroupedPositions/ErpDialogArticleGroupedPositions';
import {
  ErpDialogPositions,
  OnItemsChangedOptions,
} from './ErpDialogPositions';
import { ErpDialogSupplierGroupedPositions } from './ErpDialogSupplierGroupedPositions/ErpDialogSupplierGroupedPositions';

interface ErpDialogByModeProps
  extends Omit<
    ErpDialogArticleGroupedPositionsProps,
    'onItemsChanged' | 'onRefetch'
  > {
  onItemsChanged: (
    id: number,
    items: SelectedPosition[],
    options: OnItemsChangedOptions
  ) => void;
  showBOM: boolean;
  onRefresh: OnRefresh;
  isEditMode: boolean;
}

export const ErpDialogByMode = (props: ErpDialogByModeProps) => {
  const {
    data,
    onItemsChanged,
    sourceEntity,
    targetEntity,
    groupByType,
    showBOM,
    isEditMode,
    ...commonCollapseProps
  } = props;

  const { t } = useTranslation();

  switch (groupByType) {
    case 'SUPPLIER':
      return (
        <ErpDialogSupplierGroupedPositions
          groupByType={groupByType}
          sourceEntity={sourceEntity}
          targetEntity={targetEntity}
          onItemsChanged={(pos, options) => {
            // Save items as Group by Supplier id
            const supplierId = Number(options.key);
            onItemsChanged(
              Number.isNaN(supplierId) ? 0 : supplierId,
              pos,
              options
            );
          }}
          data={data}
          {...commonCollapseProps}
          defaultOpen={false}
          isEditMode={isEditMode}
        />
      );
    case 'NONE':
    default:
      return data.map((entry, idx) => {
        const title = (() => {
          if (groupByType === 'CONTRACT') {
            const customerNumber =
              entry?.businessPartnerContactCombined?.businessPartner?.data
                ?.number;
            const customerName =
              entry?.businessPartnerContactCombined?.businessPartner?.data
                ?.name;

            return (
              `${t('MASK.POSITIONS')} |  ${t(
                `COMMON.${sourceEntity.toUpperCase()}`
              )} ` +
              evaluateErpNumber(sourceEntity, entry) +
              (customerNumber || customerName
                ? ` | ${customerNumber} ${customerName}`
                : '')
            );
          }

          return `${t('MASK.POSITIONS')} ${
            data.length > 1
              ? ` |  ${t(`COMMON.${sourceEntity.toUpperCase()}`)} ` +
                evaluateErpNumber(sourceEntity, entry)
              : ''
          } ${
            entry?.businessPartnerContactCombined?.businessPartner?.data
              ?.name ?? ''
          }`;
        })();

        return (
          <ErpDialogPositions
            isEditMode={isEditMode}
            groupByType={groupByType}
            forceFetchAll={groupByType === 'CONTRACT'}
            autoOpen={data.length === 1}
            showTableHeader={idx === 0}
            key={entry?.id}
            sourceEntity={sourceEntity}
            targetEntity={targetEntity}
            onItemsChanged={(pos, opt) => {
              // Save items as Group by ERP id
              onItemsChanged(entry?.id, pos, opt);
            }}
            entry={entry}
            title={title}
            {...commonCollapseProps}
            defaultOpen={false}
            showBOM={showBOM}
          />
        );
      });
  }
};
